import React from 'react';

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import Routes from './routes';

function App() {
  return (
    <Box component='main'>
        <CssBaseline/>
        <ThemeProvider theme={theme}>
          <Routes/>
        </ThemeProvider>
    </Box>
  );
};

export default App;
